import { createContext, useContext, useState, ReactNode } from 'react'
import _ from 'lodash'

interface ContextProps {
  manager: {
    isLoading: boolean
    listingId: string
    progress: any
  }
  actions: any
}

const Context = createContext<ContextProps | undefined>(undefined)

// const PROGRESS_INCREMENT_FACTOR = 0.2

const StepManagerProvider = ({
  children,
}: {
  children: ReactNode
  history?: any
}) => {
  const [listingId, setListingId] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  //   const [progressIncrements, setProgressIncrements] = useState<number[]>([])

  const progress = [].reduce((sum, a) => sum + a, 0)
  //   const remainingProgress = 100 - progress

  const manager = {
    isLoading,
    listingId,
    progress,
  }
  const actions = {
    setIsLoading,
    setListingId,
  }

  return (
    <Context.Provider value={{ manager, actions }}>{children}</Context.Provider>
  )
}

const useStepManagerContext = () => {
  const context = useContext(Context)
  if (!context) {
    throw new Error('useStepManagerContext must be used within its Provider')
  }
  return context
}

export { StepManagerProvider, useStepManagerContext }
